import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { EnrollmentFormModule } from '@features/enrollment-ui/enrollment-form/enrollment-form.module';
import { MembershipDetailFormModule } from '@features/membership-ui/membership-detail-form/membership-detail-form.module';
import { EffectsModule } from '@ngrx/effects';
import { PopupModule } from '@rd/popup/popup.module';
import { PhysicalAddressFormModule } from '@rd/shared-legacy/components/physical-address-form/physical-address-form.module';
import { RecipientDetailFormModule } from '@rd/shared-legacy/components/recipient-detail-form/recipient-detail-form.module';
import { DataTestidDirective } from '@rd/shared-legacy/directives/data-testid/data-testid.directive';
import { SharedModule } from '@rd/shared-legacy/shared.module';
import { OrderItemDescriptionModule } from '@rd/shared-legacy/widgets/order-item-description/order-item-description.module';
import { AutoRedemptionCardComponent } from './components/auto-redemption-card/auto-redemption-card.component';
import { AutoRedemptionDateInputComponent } from './components/auto-redemption-date-input/auto-redemption-date-input.component';
import { AutoRedemptionDatePickerComponent } from './components/auto-redemption-date-picker/auto-redemption-date-picker.component';
import { AutoRedemptionGCSpecificAmountFormComponent } from './components/auto-redemption-gc-specific-amount-form/auto-redemption-specific-amount-form.component';
import { AutoRedemptionHowToComponent } from './components/auto-redemption-how-to/auto-redemption-how-to.component';
import { AutoRedemptionRCSpecificAmountFormComponent } from './components/auto-redemption-rc-specific-amount-form/auto-redemption-specific-amount-form.component';
import { AutoRedemptionReviewConfirmationDialogComponent } from './components/auto-redemption-review-confirmation-dialog/auto-redemption-review-confirmation-dialog.component';
import { AutoRedemptionTCSpecificAmountFormComponent } from './components/auto-redemption-tc-specific-amount-form/auto-redemption-specific-amount-form.component';
import { AutoRedemptionWrapperDialogComponent } from './components/auto-redemption-wrapper-dialog/auto-redemption-wrapper-dialog.component';
import { AutoRedemptionDatePickerDialogComponent } from './components/date-picker-dialog/date-picker-dialog.component';
import { AutoRedemptionSettingsViewNavigationEffects } from './effects/auto-redemption-navigation.effects';
import { AutoRedemptionSettingDurationPipe } from './pipes/auto-redemption-setting-duration/auto-redemption-setting-duration.pipe';
import { AutoRedemptionSettingIconPipe } from './pipes/auto-redemption-setting-icon/auto-redemption-setting-icon.pipe';
import { AutoRedemptionSettingTypePipe } from './pipes/auto-redemption-setting-type/auto-redemption-setting-type.pipe';
import { AutoRedemptionGcCheckoutDetailsComponent } from './views/auto-redemption-gc-checkout-details/gc-checkout-details.component';
import { AutoRedemptionManageComponent } from './views/auto-redemption-manage-auto-redemption/auto-redemption-manage.component';
import { AutoRedemptionReviewComponent } from './views/auto-redemption-review/review.component';
import { AutoRedemptionSettingsSuccessComponent } from './views/auto-redemption-settings-success/auto-redemption-settings-success.component';
import { AutoRedemptionTcV2MembershipCheckoutDetailsComponent } from './views/auto-redemption-tc-membership-checkout-details/tc-membership-checkout-details.component';

@NgModule({
  imports: [
    OrderItemDescriptionModule,
    DataTestidDirective,
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([AutoRedemptionSettingsViewNavigationEffects]),
    PopupModule,
    MatRadioModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MembershipDetailFormModule,
    EnrollmentFormModule,
    PhysicalAddressFormModule,
    RecipientDetailFormModule,
  ],
  declarations: [
    AutoRedemptionDatePickerDialogComponent,
    AutoRedemptionManageComponent,
    AutoRedemptionSettingIconPipe,
    AutoRedemptionSettingTypePipe,
    AutoRedemptionCardComponent,
    AutoRedemptionGcCheckoutDetailsComponent,
    AutoRedemptionHowToComponent,
    AutoRedemptionDateInputComponent,
    AutoRedemptionDatePickerComponent,
    AutoRedemptionGCSpecificAmountFormComponent,
    AutoRedemptionTCSpecificAmountFormComponent,
    AutoRedemptionRCSpecificAmountFormComponent,
    AutoRedemptionTcV2MembershipCheckoutDetailsComponent,
    AutoRedemptionWrapperDialogComponent,
    AutoRedemptionReviewComponent,
    AutoRedemptionSettingsSuccessComponent,
    AutoRedemptionSettingDurationPipe,
    AutoRedemptionReviewConfirmationDialogComponent,
  ],
  exports: [
    AutoRedemptionManageComponent,
    AutoRedemptionSettingIconPipe,
    AutoRedemptionSettingTypePipe,
    AutoRedemptionCardComponent,
    AutoRedemptionGcCheckoutDetailsComponent,
    AutoRedemptionHowToComponent,
    AutoRedemptionDateInputComponent,
    AutoRedemptionDatePickerComponent,
    AutoRedemptionGCSpecificAmountFormComponent,
    AutoRedemptionTCSpecificAmountFormComponent,
    AutoRedemptionReviewComponent,
    AutoRedemptionRCSpecificAmountFormComponent,
    AutoRedemptionSettingsSuccessComponent,
    AutoRedemptionSettingDurationPipe,
  ],
})
export class AutoRedemptionSettingsViewModule {}
